import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useListPage from 'hooks/useListPage';
const MandatedepositListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/mandatedeposit/view/${data.mdid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('mandatedeposit/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/mandatedeposit/edit/${data.mdid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('mandatedeposit/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.mdid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('mandatedeposit/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function MdidTemplate(data){
		if(data){
			return (
				<Link to={`/mandatedeposit/view/${data.mdid}`}> { data.mdid }</Link>
			);
		}
	}
	function CustomeremailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.customeremail}`}>{ data.customeremail }</a>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">{$t('records')} <b>{ recordsPosition } {$t('of')} { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="mandatedeposit/delete">
		<MultiDelete />
	</CanView>
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="MandatedepositListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('mandatedeposit')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/mandatedeposit/add`}>
                            <Button label={$t('addNewMandatedeposit')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="mdid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="mdid" header={$t('mdid')} body={MdidTemplate}  ></Column>
                                    <Column  field="policyno" header={$t('policyno')}   ></Column>
                                    <Column  field="accountholdername" header={$t('accountholdername')}   ></Column>
                                    <Column  field="accountnumber" header={$t('accountnumber')}   ></Column>
                                    <Column  field="amounttype" header={$t('amounttype')}   ></Column>
                                    <Column  field="accounttype" header={$t('accounttype')}   ></Column>
                                    <Column  field="authtype" header={$t('authtype')}   ></Column>
                                    <Column  field="bankifsc" header={$t('bankifsc')}   ></Column>
                                    <Column  field="collectionamount" header={$t('collectionamount')}   ></Column>
                                    <Column  field="customeremail" header={$t('customeremail')} body={CustomeremailTemplate}  ></Column>
                                    <Column  field="customermobile" header={$t('customermobile')}   ></Column>
                                    <Column  field="customername" header={$t('customername')}   ></Column>
                                    <Column  field="firstcollectiondate" header={$t('firstcollectiondate')}   ></Column>
                                    <Column  field="frequency" header={$t('frequency')}   ></Column>
                                    <Column  field="lastcollectiondate" header={$t('lastcollectiondate')}   ></Column>
                                    <Column  field="merchanttrxnrefid" header={$t('merchanttrxnrefid')}   ></Column>
                                    <Column  field="principalamount" header={$t('principalamount')}   ></Column>
                                    <Column  field="status" header={$t('status')}   ></Column>
                                    <Column  field="trxnid" header={$t('trxnid')}   ></Column>
                                    <Column  field="authorized" header={$t('authorized')}   ></Column>
                                    <Column  field="cancelled" header={$t('cancelled')}   ></Column>
                                    <Column  field="mdate" header={$t('mdate')}   ></Column>
                                    <Column  field="mandate_id" header={$t('mandateId')}   ></Column>
                                    <Column  field="paymentmethod_token" header={$t('paymentmethodToken')}   ></Column>
                                    <Column  field="instrumenttoken" header={$t('instrumenttoken')}   ></Column>
                                    <Column  field="bankcode" header={$t('bankcode')}   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
MandatedepositListPage.defaultProps = {
	primaryKey: 'mdid',
	pageName: 'mandatedeposit',
	apiPath: 'mandatedeposit/index',
	routeName: 'mandatedepositlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default MandatedepositListPage;
